import { render, staticRenderFns } from "./TrafficEditor.vue?vue&type=template&id=e345a3ce"
import script from "./TrafficEditor.vue?vue&type=script&lang=js"
export * from "./TrafficEditor.vue?vue&type=script&lang=js"
import style0 from "./TrafficEditor.vue?vue&type=style&index=0&id=e345a3ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports